"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledChip = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importStar(require("styled-components"));
const getChipColors = ({ $accent, $isUnknown }) => {
    if ($isUnknown) {
        return (0, styled_components_1.css) `
      background: #FFEBEB;
      border: 1px solid #FFB5B9;
      color: #B3261E;
    `;
    }
    return (0, styled_components_1.css) `
    border: 1px solid ${$accent ? ui_components_1.baseColors.blue300 : ui_components_1.baseColors.primaryBlueMed200};
    color: ${$accent ? ui_components_1.baseColors.blue300 : ui_components_1.baseColors.background700};
  `;
};
exports.StyledChip = (0, styled_components_1.default)(material_1.Chip) `
  &&.MuiAutocomplete-tag {
    max-width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
    border-radius: 20px;
    padding: ${({ theme }) => theme.spacing(0.5, 1)};
    margin: ${({ theme }) => theme.spacing(0.25)};
    font-weight: 500;
    font-size: 1rem;

    ${getChipColors}

    .MuiChip-label {
      font-size: 0.875rem;
    }

    svg:not(.MuiChip-deleteIcon) {
      font-size: 1.5rem;
      color: currentColor;
    }

    .MuiChip-deleteIcon {
      color: currentColor;
      ${({ $isUnknown }) => $isUnknown && (0, styled_components_1.css) `
        display: none;
      `}
    }
  }
`;
